import { render, staticRenderFns } from "./importTab.vue?vue&type=template&id=13caab84&scoped=true&"
import script from "./importTab.vue?vue&type=script&lang=js&"
export * from "./importTab.vue?vue&type=script&lang=js&"
import style0 from "./importTab.vue?vue&type=style&index=0&id=13caab84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13caab84",
  null
  
)

component.options.__file = "importTab.vue"
export default component.exports